const COLOR_CLASSES = {
  indigo: {
    active: "bg-indigo-600 text-white shadow-sm hover:shadow-md",
    badge: "bg-indigo-500 text-white",
    hover: "hover:bg-indigo-50 hover:text-indigo-600",
  },
  blue: {
    active: "bg-blue-600 text-white shadow-sm hover:shadow-md",
    badge: "bg-blue-500 text-white",
    hover: "hover:bg-blue-50 hover:text-blue-600",
  },
  emerald: {
    active: "bg-emerald-600 text-white shadow-sm hover:shadow-md",
    badge: "bg-emerald-500 text-white",
    hover: "hover:bg-emerald-50 hover:text-emerald-600",
  },
  amber: {
    active: "bg-amber-600 text-white shadow-sm hover:shadow-md",
    badge: "bg-amber-500 text-white",
    hover: "hover:bg-amber-50 hover:text-amber-600",
  },
  red: {
    active: "bg-red-600 text-white shadow-sm hover:shadow-md",
    badge: "bg-red-500 text-white",
    hover: "hover:bg-red-50 hover:text-red-600",
  },
};

export default function FilterTabs({
  filters = [],
  activeFilter,
  onChange,
  totalCount,
  isLoading = false,
  color = "indigo",
  // Veri yokken sekmeler gorunur kalir ama basilamaz — bos listede filtre
  // secmek anlamsiz ve kullaniciya "bir sey oldu" hissi veriyor.
  disabled = false,
  // Çoklu seçim: activeFilter bir DİZİ olur, birden fazla sekme aynı anda
  // aktif görünür; seçimi aç/kapat yapmak çağıranın işidir (onChange id verir).
  // Çoklu modda her sekme kendi filter.count'unu gösterir. Varsayılan false.
  multiple = false,
}) {
  const tokens = COLOR_CLASSES[color] || COLOR_CLASSES.indigo;

  return (
    <div className="flex gap-2 mb-3 sm:mb-4 overflow-x-auto pb-1 scrollbar-hide -mx-1 px-1">
      {filters.map((filter) => {
        const isActive = multiple
          ? Array.isArray(activeFilter) && activeFilter.includes(filter.id)
          : activeFilter === filter.id;
        // Sayaç mantığı: aktif tab → totalCount (eski davranış);
        // diğer tab'lar → filter.count (varsa). Çoklu modda hep filter.count.
        const useTotal = isActive && !multiple;
        const showCount = useTotal
          ? totalCount !== undefined
          : filter.count !== undefined;
        const countValue = useTotal ? totalCount : filter.count;
        return (
          <button
            key={filter.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(filter.id)}
            className={`
              flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium transition-all duration-200 whitespace-nowrap shrink-0
              disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none
              ${
                isActive
                  ? tokens.active
                  : `bg-white text-gray-600 border border-gray-200 ${
                      disabled ? "" : tokens.hover
                    }`
              }
            `}
          >
            {filter.icon && (
              <filter.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            )}
            <span>{filter.label}</span>
            {filter.dot && (
              <span className="relative flex h-2 w-2 ml-0.5">
                <span
                  className={`animate-ping absolute inline-flex h-full w-full rounded-full ${
                    isActive ? "bg-white" : "bg-amber-400"
                  } opacity-75`}
                />
                <span
                  className={`relative inline-flex rounded-full h-2 w-2 ${
                    isActive ? "bg-white" : "bg-amber-500"
                  }`}
                />
              </span>
            )}
            {showCount && (
              <span
                className={`ml-1 sm:ml-2 ${
                  isActive
                    ? tokens.badge
                    : "bg-gray-100 text-gray-600 border border-gray-200"
                } text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 rounded-md sm:rounded-lg flex items-center justify-center min-w-[24px] sm:min-w-[28px]`}
              >
                {useTotal && isLoading ? (
                  <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  countValue
                )}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
